// 必吃大瓜 站内头条与精选内容库（娱乐评论 / 热闻盘点 / 吃瓜观察）
// windows: today=今日重磅 week=本周必看 month=本月最劲爆 year=年度盘点

export type WindowKey = 'today' | 'week' | 'month' | 'year';

export interface Story {
  id: string;
  title: string;
  dek: string;
  category: '综艺' | '影视' | '明星' | '行业';
  windows: WindowKey[];
  source: string;
  timeLabel: string;
  readMin: number;
  heat: string;
  tags: string[];
  cover: string;
  body: string[];
}

export const featuredStories: Story[] = [
  {
    id: 'kaipan-zongyi-2026',
    title: '综艺「回锅」元年观察：综N代为何越做越聪明？',
    dek: '从模式照搬到本土化再造，热门综艺的「第二春」并非偶然。编辑部拆解今年综艺回暖背后的三条暗线。',
    category: '综艺',
    windows: ['today', 'week', 'month', 'year'],
    source: '必吃大瓜·策划',
    timeLabel: '今日 08:30',
    readMin: 6,
    heat: '128万',
    tags: ['综艺回锅', '平台观察', '独家拆解'],
    cover:
      'https://readdy.ai/api/search-image?query=empty%20bright%20tv%20studio%20with%20neon%20ring%20lights%20and%20soft%20warm%20light%2C%20editorial%20concept%20photography%2C%20cinematic%20composition%2C%20vibrant%20yet%20clean%20warm%20tones&width=900&height=560&seq=guazongyi-2026-x1&orientation=landscape',
    body: [
      '当「综N代」遇上观众审美疲劳，是清盘还是加码，一度成为平台最纠结的命题。今年多档常青节目不约而同选择了「轻翻新」路线：保留熟悉的主咖人设，却把赛制、舞美和叙事节奏全部重做，反而迎来口碑与热度的双回升。',
      '细看之下，真正的胜负手在于「把镜头还给普通人」。从选手选角到现场支线，越来越多真实情绪被保留下来，观众要的不是完美剧本，而是能被代入的「活人感」。这恰恰是过去刻意制造冲突时最容易丢掉的东西。',
      '行业人士判断，综艺的下一轮竞争不再比拼大牌堆砌，而是考验平台对用户情绪颗粒度的理解。谁先学会「慢下来做内容」，谁就可能赢下更长周期的注意力。必吃大瓜将持续跟踪各平台后续动作，第一时间为你复盘。',
    ],
  },
  {
    id: 'guochan-xiju-dianshi',
    title: '国产剧集「短精」风潮：8集讲完一个好故事',
    dek: '动辄五六十集的注水时代正在退潮，一批单季8到12集的剧集用高密度叙事重新圈回观众。',
    category: '影视',
    windows: ['today', 'week'],
    source: '必吃大瓜·剧评',
    timeLabel: '今日 07:10',
    readMin: 5,
    heat: '86万',
    tags: ['国产剧', '短剧集', '剧评'],
    cover: '',
    body: [
      '过去观众对「国产剧又臭又长」的抱怨，正在被一种新的体量共识修正。单季8到12集的悬疑、都市与年代剧接连上线，它们砍掉注水副线，让每场戏都同时承担情绪与信息两种功能。',
      '这种「短精」背后是内容供给侧的自我革命：制作方把预算从集数摊平，集中砸向编剧、演员与美术质感，换来的是完播率和二创讨论的双双抬升。平台数据也印证，观众更愿意为一口气能追完的完整故事付费。',
      '当然，「短」不等于「好」。真正决定口碑的，依旧是人物是否立得住、情感是否真诚。编辑部认为，短剧集时代考验的是编剧的「克制力」，这也是国产内容走向成熟的标志。',
    ],
  },
  {
    id: 'yanchuhui-yinle-pan',
    title: '一场演唱会带火一座城：演出经济的「双向奔赴」',
    dek: '歌迷为一场演出跨越山海，城市为一份热情亮出诚意。演出与文旅的联动，正在重塑假期消费版图。',
    category: '行业',
    windows: ['today', 'month', 'year'],
    source: '必吃大瓜·观察',
    timeLabel: '今日 06:45',
    readMin: 7,
    heat: '143万',
    tags: ['演唱会经济', '文旅', '消费观察'],
    cover:
      'https://readdy.ai/api/search-image?query=crowded%20open%20air%20concert%20at%20dusk%20with%20warm%20golden%20stage%20lighting%20and%20fans%20holding%20phone%20flashlights%2C%20warm%20candid%20editorial%20photography%2C%20cinematic%20atmosphere&width=1200&height=720&seq=guayanchu-2026-x2&orientation=landscape',
    body: [
      '「为一场演出，赴一座城」正在从粉丝圈层扩散为大众出行方式。演出场馆周边的酒店、餐饮、本地交通在档期内同步走热，一座二三线城市也常常因一场万人演唱会迎来罕见的客流高峰。',
      '这背后是主办方、艺人与地方政府越来越默契的协同：延长深夜地铁、开放临时停车场、联动本地特产消费券，把「观演」延展成「两日游」。数据显示，大型演出每带动一张门票，往往能拉动数倍于票面的周边消费。',
      '值得注意的是，供需两旺之下也考验城市的承接能力。编辑部建议，理性看待热度、提前做好预案的城市，才能真正把「一场演唱会」变成「一张长期文旅名片」。',
    ],
  },
  {
    id: 'liuxingyuan-shenshi',
    title: '「考古式追星」走红：怀旧情绪为何总在深夜刷屏',
    dek: '翻出十年前的舞台、老剧与旧歌，年轻网友在「考古」里找回了被快节奏稀释的踏实感。',
    category: '明星',
    windows: ['week', 'month'],
    source: '必吃大瓜·文化',
    timeLabel: '昨日 21:40',
    readMin: 5,
    heat: '92万',
    tags: ['考古文化', '怀旧', '粉丝圈'],
    cover: '',
    body: [
      '平台热榜上，一类内容正以稳定速度刷屏：被反复搬运的十年前舞台直拍、老剧名场面剪辑、以及被重新解读的经典歌词。网友把它戏称为「考古式追星」，在碎片化的当下反而长成一种集体仪式。',
      '心理学视角下，怀旧提供的是确定性与安全感——当眼前信息过载，人们会退回记忆里那些「已知结局」的作品，从中获得短暂的情绪避风港。这也是为何深夜「考古」视频往往拥有点赞高峰。',
      '对内容行业而言，这股情绪同样意味着机会：版权方开始主动拥抱老作品的二次传播，用「正版考古」承接流量，让经典在新生代观众中完成新一轮价值重估。',
    ],
  },
  {
    id: 'ai-shipin-shencha',
    title: 'AI换脸与合成内容监管收紧，理性吃瓜有了新护栏',
    dek: '眼见未必为实。随着AI合成内容识别与标注规则落地，「先求证再转发」成为新一代网民的必备素养。',
    category: '行业',
    windows: ['week', 'year'],
    source: '必吃大瓜·专栏',
    timeLabel: '本周一',
    readMin: 8,
    heat: '77万',
    tags: ['AI治理', '理性吃瓜', '平台规则'],
    cover: '',
    body: [
      '一段看似真实的画面，可能从表情、声音到口型都由算法生成。随着AI合成技术门槛降低，网络上开始出现大量难辨真假的「爆料视频」，给明星、品牌乃至普通人都带来名誉风险。',
      '好消息是，内容平台与监管规则正在同步补课：合成内容须显著标注、首发平台承担核验义务、恶意造谣账号面临更严厉的处置。多平台也已上线「一键举报疑似AI内容」入口，把求证成本从用户端部分转移到平台端。',
      '对每一位吃瓜人而言，这意味着「理性吃瓜」不再只是口号，而是一套可执行的守则：看官方信源、查合成标识、等双方回应。必吃大瓜愿与你一起，把「看热闹」升级成「看门道」。',
    ],
  },
  {
    id: 'lianyi-gaoxiao-wu',
    title: '真实or剧本？真人秀「反套路」剪辑为何赢麻了',
    dek: '当观众腻了「剪辑造冲突」，把意外和失控大方剪进去的节目，反而成了话题中心。',
    category: '综艺',
    windows: ['week', 'month'],
    source: '必吃大瓜·策划',
    timeLabel: '本周三',
    readMin: 6,
    heat: '134万',
    tags: ['真人秀', '剪辑', '话题综艺'],
    cover:
      'https://readdy.ai/api/search-image?query=colorful%20reality%20show%20film%20set%20with%20multiple%20television%20monitors%20and%20editing%20timeline%20glow%2C%20warm%20amber%20and%20crimson%20lighting%2C%20editorial%20concept%20photography&width=900&height=560&seq=guazhenxiu-2026-x3&orientation=landscape',
    body: [
      '真人秀最怕「假」，但早年被反复吐槽的恰恰是「处处透着编排」。今年风向变了：一档把失误、冷场与成员间的尴尬瞬间原样保留的节目，意外获得最高讨论度。观众直言「终于不再把我们当傻子」。',
      '剪辑师们也开始公开分享「不救场」的创作观：宁可节奏慢一点，也要把人物的真实反应留住。因为精心设计的反转再多，也比不上一次毫无防备的破防更能击中人心。',
      '当然，「真实感」本身也可能成为新的包装。编辑部提醒，判断一档真人秀值不值得追，不妨看它是否愿意把镜头对准「狼狈与笨拙」——那里往往藏着最难得的东西。',
    ],
  },
  {
    id: 'zhoudian-dianying-qi',
    title: '档期电影与「口碑发酵」：首周排片决定成败的迷思',
    dek: '首日票房真的能定生死吗？编辑部复盘多部作品后发现，「口碑后程」越来越常创造反超奇迹。',
    category: '影视',
    windows: ['week', 'month'],
    source: '必吃大瓜·影评',
    timeLabel: '上周五',
    readMin: 6,
    heat: '65万',
    tags: ['电影档期', '票房', '影评'],
    cover: '',
    body: [
      '在「首日即决战」的惯性思维下，片方习惯把宣发预算集中砸向开画头三天。但复盘今年几部黑马作品会发现，首周排片被头部大片挤压的中小成本影片，正靠自来水口碑在次周完成漂亮的反超。',
      '社交平台的「看完再说」机制正在改写规则：越来越多观众习惯先看评分区的真实评价，再决定是否买票。这让「长尾口碑」成为比首日声势更可靠的票房引擎，也倒逼宣发从「砸热度」转向「护口碑」。',
      '可以预见，未来档期竞争会更像一场马拉松。谁能把前期的克制转化为观众的信任，谁就更有机会在后半程迎来属于自己的一浪。必吃大瓜会持续为你盯紧每周新片的风向变化。',
    ],
  },
  {
    id: 'jingji-ren-nianhuo',
    title: '「艺人个人厂牌」兴起：经纪关系的下一站在哪里',
    dek: '顶流自立门户、工作室全权操盘渐成主流，行业分工正从「管理」转向「共事」。',
    category: '行业',
    windows: ['month', 'year'],
    source: '必吃大瓜·观察',
    timeLabel: '本月上旬',
    readMin: 7,
    heat: '111万',
    tags: ['艺人经纪', '厂牌', '行业变革'],
    cover: '',
    body: [
      '「合约到期，不再续约，感谢多年栽培」——这类公告近两年愈发频繁，其背后是艺人个人厂牌与全约工作室的全面兴起。对成熟艺人而言，独立既意味着更大的创作自由度，也意味着自己为项目风险兜底。',
      '行业链条随之重构：传统经纪公司转向孵化新人、打通商务资源的中台角色；艺人与团队的协作更接近「合伙人」而非「老板与雇员」。这也让艺人个人的商业判断与法务素养被提到了前所未有的高度。',
      '当然，独立不等于万能解。缺乏专业团队的艺人同样面临资源断档风险。编辑部认为，无论模式如何演进，专业、诚信与长期主义，始终是这场关系实验里最不该被牺牲的底线。',
    ],
  },
  {
    id: 'zongyi-chuhai-re',
    title: '国产综艺「出海」提速：从被引进到被输出',
    dek: '一批原创模式成功授权海外平台，中国综艺开始交出「反向输出」的答卷。',
    category: '行业',
    windows: ['month', 'year'],
    source: '必吃大瓜·策划',
    timeLabel: '本月中旬',
    readMin: 8,
    heat: '98万',
    tags: ['综艺出海', '模式授权', '文化输出'],
    cover:
      'https://readdy.ai/api/search-image?query=globe%20with%20television%20and%20clapperboard%20concept%2C%20warm%20golden%20and%20crimson%20editorial%20backdrop%2C%20international%20media%20exhibition%20atmosphere%2C%20high%20detail&width=1000&height=600&seq=guachuhai-2026-x4&orientation=landscape',
    body: [
      '曾几何时，国产综艺的案头常摆着海外模式的参考书；如今风向逆转——多档原创综艺相继达成海外模式授权，从节目框架到「观察+真人」的核心理念，都被复制到不同文化土壤并顺利落地。',
      '出海提速离不开本土经验的沉淀。多年赛制打磨让「中国式情感观察」形成可迁移的方法论：它既保留人性共通点，又给当地团队留足本地化空间。比起「整套复制」，「模式+授权+联合制作」显然走得更稳。',
      '文化出海从来不是单向输出。编辑部认为，真正可持续的出海，是在对话中互相加分——当海外版把我们的原创模式做出口碑，本身就是对内容质量最有力的背书。',
    ],
  },
  {
    id: 'wugugua-nianpan',
    title: '年度吃瓜盘点预告：编辑部选出今年最值得回味的五件事',
    dek: '临近年度，编辑部开始整理一年里的高光与反转。这份「预告片」先带你重温属于观众的集体记忆。',
    category: '综艺',
    windows: ['year'],
    source: '必吃大瓜·盘点',
    timeLabel: '年度策划',
    readMin: 5,
    heat: '203万',
    tags: ['年度盘点', '高光时刻', '预告'],
    cover: '',
    body: [
      '又到一年复盘时。回望这一年，从综艺赛制的集体焕新，到剧集「短精」的异军突起，再到演出与文旅的深度联动，观众用一次次「真香」与「上头」投出了自己的票。',
      '编辑部内部已完成多轮争论，最终圈定五件「年度之最」：最具话题性的综艺翻红、最令圈内意外的口碑黑马、最出圈的怀旧考古、最引发行业深思的模式出海，以及最牵动每个人的理性吃瓜共识。',
      '完整榜单与颁奖词将随必吃大瓜年度盘点专题陆续放送，敬请蹲守。别忘了把这份「预告」转给同样爱看热闹的朋友，一起等正片。',
    ],
  },
];

export const heroOrder: string[] = [
  'kaipan-zongyi-2026',
  'yanchuhui-yinle-pan',
  'ai-shipin-shencha',
];

export const weeklyIds: string[] = [
  'kaipan-zongyi-2026',
  'guochan-xiju-dianshi',
  'liuxingyuan-shenshi',
  'ai-shipin-shencha',
  'lianyi-gaoxiao-wu',
];

export const monthlyIds: string[] = [
  'yanchuhui-yinle-pan',
  'liuxingyuan-shenshi',
  'lianyi-gaoxiao-wu',
  'guochan-xiju-dianshi',
  'zhoudian-dianying-qi',
  'jingji-ren-nianhuo',
];

export const yearlyIds: string[] = [
  'wugugua-nianpan',
  'yanchuhui-yinle-pan',
  'ai-shipin-shencha',
  'jingji-ren-nianhuo',
  'zongyi-chuhai-re',
  'kaipan-zongyi-2026',
  'lianyi-gaoxiao-wu',
];